<template>
  <el-form ref="formRef" :model="formState">
    <el-row :gutter="16">
      <el-col :span="12">
        <el-form-item label="授信金额（元）" prop="creditAmount">
          <RxkInput
            :formatter="moneyFormatter"
            :parser="moneyParser"
            v-model="formState.creditAmount"
            disabled
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="授信起始日" prop="creditBeginTime">
          <RxkDatePicker type="date" v-model="formState.creditBeginTime" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="授信到期日" prop="creditEndTime">
          <RxkDatePicker type="date" v-model="formState.creditEndTime" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="贷款类型" prop="loanType">
          <RxkSelect v-model="formState.loanType" disabled :list="loanTypeList" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否共同贷款" prop="jointLoanFlag">
          <RxkSelect v-model="formState.jointLoanFlag" disabled :list="jointLoanFlagList" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script lang="ts" setup>
import { RxkInput, RxkSelect } from '@/components/common'
import { RxkDatePicker } from '@/components/common/RxkDatePicker'
import { loanTypeList, jointLoanFlagList } from '@/views/erp/enums'
import { moneyFormatter, moneyParser } from '@/utils/money'

interface FormState {
  [x: string]: any
  creditAmount: string //	授信金额		false
  creditEndTime: string //	授信到期日		false
  creditBeginTime: string // 授信起始日
  loanType: string //	贷款类型		false
  jointLoanFlag: string //	是否共同贷款		false
}

const props = defineProps({
  formValue: {
    type: Object as PropType<FormState>,
    default: () => ({})
  },
  permissions: {
    type: Object,
    default: () => ({})
  }
})

const formRef = ref()

const formState = reactive<FormState>({
  creditAmount: '',
  creditEndTime: '',
  creditBeginTime: '',
  loanType: '',
  jointLoanFlag: ''
})

onMounted(() => {
  for (let key in formState) {
    formState[key] = props.formValue[key]
  }
})

async function sure() {
  const valid = formRef.value.validate()
  if (valid) {
    return { ...formState }
  }
  return false
}

defineExpose({
  sure
})
</script>
